module.exports = __webpack_public_path__ + "static/CrimsonText-Italic-b9c3c7d6fa32c3a0f7eb14d4c3bf554c.woff2";